import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(group, chtData) {

      let main = this.title.main
      let sub = this.title.sub

      let canvas = this.canvasChart
      .append('g')
      .attr('transform', `translate(${group.x}, ${group.y})`)

      if(main.visible == 'Y'){
        canvas
        .append('text')
        .attr('id', `TITLE_MAIN_${group.id}_${this.localId}`)
        .attr('x', main.x) .attr('y', main.y)
        .style('font-size', main.tSize).style('fill', main.tColor)
        .text(()=> {
          if(main.name == '') return group.main; else return main.name
        })
      }

      if(sub.visible == 'Y'){
        let main_x = this.getNode(`#TITLE_MAIN_${group.id}_${this.localId}`)+5
        canvas
        .append('text')
        .attr('id', `TITLE_SUB_${group.id}_${this.localId}`)
        .attr('x', (sub.x=='auto') ? main_x : sub.x)
        .attr('y', sub.y)
        .style('font-size', sub.tSize).style('fill', sub.tColor)
        .text(()=> {
          if(sub.name == '') return group.sub; else return sub.name
        })

      }

      this.draw_Timeline(canvas, group) // -----> draw_Timeline.js
      this.draw_ChartAxis(canvas) //-----> below
      this.draw_Grid(canvas) //-----> below
      if(this.legends.visible == 'Y') this.draw_Legends(canvas, group) //-----> below


      this.draw_BarChart(canvas, group, chtData) // -----> draw_Chart.js
      this.draw_LineChart(canvas, chtData)

      if(this.table.apply == 'Y')this.draw_Table(canvas, chtData)
    },

    

    draw_ChartAxis(selection) {

      let axes = selection

      // Primary
      axes
      .append('line')
      .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', this.primary.stroke).attr('stroke-width', .5).attr('opacity', this.primary.stroke ? 1 : 0)

      axes 
      .append('text')
      .attr('transform', `translate(${-this.primary.padding}, ${this.chart.height/2 + this.primary.tSize*0.4}) rotate(-90)`)
      .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.primary.title)

      
      axes
      .append('line')
      .attr('x1', this.chart.width).attr('x2', this.chart.width).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', this.secondary.stroke).attr('stroke-width', .5).attr('opacity', this.secondary.stroke ? 1 : 0)

      // Secondary
      if(this.secondary.visible == 'Y') {
        axes 
        .append('text')
        .attr('transform', `translate(${this.chart.width + this.secondary.padding}, ${this.chart.height/2 + this.secondary.tSize*0.4}) rotate(-90)`)
        .attr('font-size', this.secondary.tSize).attr('fill', this.secondary.tColor)
        .attr('text-anchor', 'middle')
        .text(this.secondary.title)
      }
    },



    draw_Grid(selection) {
      let tick = this.chart.height / 5
      let grids = selection

      for(let i=0; i<6; i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5).attr('opacity', .5)

        grids // Primary
        .append('text')
        .attr('x', -2).attr('y', this.chart.height - (tick * i) + 3)  
        .attr('font-size', this.grid.tSize).attr('fill', this.grid.tColor)
        .attr('text-anchor', 'end')
        .text(()=> {
          let value = (this.primary.max * (i*.2)).toFixed(this.primary.round)
          if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
          return value + this.primary.unit
        })

        if(this.secondary.visible == 'Y') {
          grids // Secondary
          .append('text')
          .attr('x', this.chart.width + 2)
          .attr('y', this.chart.height - (tick * i) + 3)  
          .attr('font-size', this.grid.tSize).attr('fill', this.grid.tColor)
          .text(()=> {
            let value = (this.secondary.max * (i*.2)).toFixed(this.secondary.round)
            if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value + this.secondary.unit
          })
        }

      }
    },



    draw_Legends(selection, group) {

      let this_ = this
      let legendGroup = selection
      .append('g')
      .attr('id', `LEGEND_GROUP_${group.id}_${this.localId}`)
      .attr('transform', `translate(${1}, ${this.legends.y})`)
      
      let x_ = 0
      
      this.chart.styles.forEach((d,i)=> {

        let item = legendGroup
        .append('g')
        .attr('id', `LEGEND_${i}_${group.id}_${this.localId}`)
        .attr('transform', `translate(${x_}, 0)`)
        .attr('cursor', 'pointer').attr('opacity', 1)
        .on('mouseover', function() {
          d3.select(this).transition().duration(100).attr('opacity', 0.5)
          this_.chart.styles.forEach((st,s)=> {
             d3.selectAll(`.BAR_${group.id}_${s}_${this_.localId}`).transition().duration(150).attr('opacity', (i==s) ? 1 : .2)
             d3.selectAll(`.VALUE_${group.id}_${s}_${this_.localId}`).transition().duration(150).attr('fill', (i==s) ? '#000' : '#bcbcbc')
             d3.selectAll(`.TOT_${group.id}_${this_.localId}`).transition().duration(150).attr('opacity', 0.1)
          })
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(200).attr('opacity', 1)
          this_.chart.styles.forEach((st,s)=> {
            d3.selectAll(`.BAR_${group.id}_${s}_${this_.localId}`).transition().duration(300).attr('opacity', d.opacity)
            d3.selectAll(`.VALUE_${group.id}_${s}_${this_.localId}`).transition().duration(300).attr('fill', st.vColor)
            d3.selectAll(`.TOT_${group.id}_${this_.localId}`).transition().duration(150).attr('opacity', 1)
          })
        })

        item
        .append('rect')
        .attr('x', 0)
        .attr('y', (d.type=='LINE') ? 3 : 0)
        .attr('width', 6)
        .attr('height', (d.type=='LINE') ? 1 : 6)
        .attr('fill', d.bColor).attr('stroke', d.bColor)

        item
        .append('text')
        .attr('transform', `translate(${10}, ${3 + this.legends.tSize*0.4})`)
        .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
        .text(d.name)

        x_ = x_ + this.getNode(`#LEGEND_${i}_${group.id}_${this.localId}`) + 10
      })

      let len = this.getNode(`#LEGEND_GROUP_${this.localId}`, 'width')
      if(this.legends.align == 'center') {
        d3.select(`#LEGEND_GROUP_${this.localId}`)
        .attr('transform', `translate(${this.chart.x + (this.chart.width/2) - (len/2)}, ${this.legends.y})`)
      }
      if(this.legends.align == 'right') {
        d3.select(`#LEGEND_GROUP_${this.localId}`)
        .attr('transform', `translate(${this.chart.x + this.chart.width - len - 1}, ${this.legends.y})`)
      }
    },

  }
}
